import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';

import { ERROR, SUCCESS, WARNING } from '../../../../utils/constants';

import { removeSystemNotice } from '../../../../slices/system/system.slice';

import { getClassNames } from '../../../../utils/util';

import './system-notice.scss';

const SystemNotice = ({ notice }) => {
  const [entering, setEntering] = useState(true);
  const [leaving, setLeaving] = useState(false);

  const dispatch = useDispatch();

  useEffect(() => {
    const enterTimeout = setTimeout(() => setEntering(false), 200);
    const leavingTimeout = setTimeout(() => setLeaving(true), 5000);

    return () => {
      clearTimeout(enterTimeout);
      clearTimeout(leavingTimeout);
    };
  }, []);

  useEffect(() => {
    if (leaving) {
      const timeout = setTimeout(() => dispatch(removeSystemNotice(notice.id)), 150);

      return () => clearTimeout(timeout);
    }
  }, [dispatch, leaving, notice.id]);

  return (
    <div
      className={getClassNames('system-notice', {
        entering,
        leaving,
        success: notice.type === SUCCESS,
        warning: notice.type === WARNING,
        error: notice.type === ERROR,
      })}
      data-testid="system-notice"
    >
      <p>{notice.message}</p>
    </div>
  );
};

SystemNotice.propTypes = {
  notice: PropTypes.shape({}),
};

export default SystemNotice;
